<div class="page-title">{{ 'MGMT_DETAILS.Notes' | translate }}</div>

<div class="note-list">
  <app-note-list [config]="notes.open"></app-note-list>
  <app-note-list *ngIf="isClosedNotesAvailable" [config]="notes.closed"></app-note-list>
</div>
